exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tips {\n  color: #f00;\n  font-size: 12px;\n  line-height: 20px;\n}\n", ""]);

// exports
